import { createFileRoute } from '@tanstack/react-router';
import { AdminSkusPage } from '../../../../features/admin/market';

export const Route = createFileRoute('/_auth/admin/market/')({
  component: AdminSkusPage,
});
